export default __webpack_public_path__ + "static/media/qa.740b512e.svg";